import script from "./AdminCategoriesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCategoriesPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminCategoriesPage.vue?vue&type=style&index=0&id=014cdbb0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-014cdbb0"]])

export default __exports__